import React, { useEffect, useState } from "react";
import { Thumbnail } from "./thumbnail";
import { useFunctions } from "./useFunctions";
// Import Swiper React components
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
export var System = function () {
    var BASEURL = "";
    var TOTALSTEP = 12;
    var _a = useState(false), isStart = _a[0], setIsStart = _a[1];
    var _b = useState(false), isEnd = _b[0], setIsEnd = _b[1];
    var _c = useState(0), stepIndex = _c[0], setStepIndex = _c[1];
    var _d = useState([
        {
            category: "japanese-modern",
            score: 0,
            title: "和モダン",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL +
                "/wp-content/themes/main-theme/img/like-system/japanese-modern.png",
            slideimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/header_01.png",
            slideimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/header_02.png",
            slideimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/header_03.png",
            pointimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/thumb_01.png",
            pointimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/thumb_02.png",
            pointimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/jp-modern/thumb_03.png",
            buttonUrl: BASEURL + "/japanese-modern",
        },
        {
            category: "natural",
            score: 0,
            title: "ナチュラル",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/natural.png",
            slideimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/natural/header_01.png",
            slideimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/natural/header_02.png",
            slideimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/natural/header_03.png",
            pointimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/natural/thumb_01.png",
            pointimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/natural/thumb_02.png",
            pointimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/natural/thumb_03.png",
            buttonUrl: BASEURL + "/natural",
        },
        {
            category: "chic",
            score: 0,
            title: "シック",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/chic.png",
            slideimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/chic/header_01.png",
            slideimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/chic/header_02.png",
            slideimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/chic/header_03.png",
            pointimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/chic/thumb_01.png",
            pointimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/chic/thumb_02.png",
            pointimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/chic/thumb_03.png",
            buttonUrl: BASEURL + "/chic",
        },
        {
            category: "nordic",
            score: 0,
            title: "北欧",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/nordic.png",
            slideimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/header_01.png",
            slideimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/header_02.png",
            slideimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/header_03.png",
            pointimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/thumb_01.png",
            pointimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/thumb_02.png",
            pointimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/nordic/thumb_03.png",
            buttonUrl: BASEURL + "/nordic",
        },
        {
            category: "vintage",
            score: 0,
            title: "ヴィラリゾート",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/vintage.png",
            slideimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/header_01.png",
            slideimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/header_02.png",
            slideimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/header_03.png",
            pointimageUrl1: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/thumb_01.png",
            pointimageUrl2: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/thumb_02.png",
            pointimageUrl3: BASEURL + "/wp-content/themes/main-theme/img/design/vintage/thumb_03.png",
            buttonUrl: BASEURL + "/vintage",
        },
    ]), patterns = _d[0], setPatterns = _d[1];
    var _e = useFunctions({
        setStepIndex: setStepIndex,
        patterns: patterns,
        setPatterns: setPatterns,
    }), plusStep = _e.plusStep, updateScore = _e.updateScore;
    var _f = useState(null), question = _f[0], setQuestion = _f[1], _g = useState(null), title = _g[0], setTitle = _g[1], _h = useState(null), description = _h[0], setDescription = _h[1], _j = useState(null), imageUrl = _j[0], setImageUrl = _j[1], _k = useState(null), slideimageUrl1 = _k[0], setSlideImageUrl1 = _k[1], _l = useState(null), slideimageUrl2 = _l[0], setSlideImageUrl2 = _l[1], _m = useState(null), slideimageUrl3 = _m[0], setSlideImageUrl3 = _m[1], _o = useState(null), pointimageUrl1 = _o[0], setPointImageUrl1 = _o[1], _p = useState(null), pointimageUrl2 = _p[0], setPointImageUrl2 = _p[1], _q = useState(null), pointimageUrl3 = _q[0], setPointImageUrl3 = _q[1], _r = useState(null), buttonUrl = _r[0], setButtonUrl = _r[1];
    useEffect(function () {
        switch (stepIndex) {
            case 1:
                setQuestion("どのダイニングテーブルがコノミ？");
                break;
            case 2:
                setQuestion("どのソファーがコノミ？");
                break;
            case 3:
                setQuestion("どのダイニングチェアがコノミ？");
                break;
            case 4:
                setQuestion("どのテレビボードがコノミ？");
                break;
            case 5:
                setQuestion("どの照明がコノミ？");
                break;
            case 6:
                setQuestion("どのダイニングチェアがコノミ？");
                break;
            case 7:
                setQuestion("どのソファーがコノミ？");
                break;
            case 8:
                setQuestion("どの照明がコノミ？");
                break;
            case 9:
                setQuestion("どのクロスがコノミ？");
                break;
            case 10:
                setQuestion("どの壁・クロスがコノミ？");
                break;
            case 11:
                setQuestion("どのフローリングがコノミ？");
                break;
            case TOTALSTEP:
                handleComplete();
                setIsEnd(true);
                break;
            default:
                break;
        }
    }, [stepIndex]);
    function handleComplete() {
        var lastScore = patterns.map(function (p) {
            return p.score;
        });
        var result = patterns.find(function (item) { return item.score === Math.max.apply(null, lastScore); });
        setTitle(result.title);
        setDescription(result.description);
        setImageUrl(result.imageUrl);
        setSlideImageUrl1(result.slideimageUrl1);
        setSlideImageUrl2(result.slideimageUrl2);
        setSlideImageUrl3(result.slideimageUrl3);
        setPointImageUrl1(result.pointimageUrl1);
        setPointImageUrl2(result.pointimageUrl2);
        setPointImageUrl3(result.pointimageUrl3);
        setButtonUrl(result.buttonUrl);
    }
    function handleReset() {
        setIsEnd(false);
        setIsStart(false);
        setStepIndex(1);
        setPatterns(function (prevState) {
            return prevState.map(function (obj) {
                return true
                    ? {
                        category: obj.category,
                        score: 0,
                        title: obj.title,
                        description: obj.description,
                        imageUrl: obj.imageUrl,
                        slideimageUrl1: obj.slideimageUrl1,
                        slideimageUrl2: obj.slideimageUrl2,
                        slideimageUrl3: obj.slideimageUrl3,
                        pointimageUrl1: obj.pointimageUrl1,
                        pointimageUrl2: obj.pointimageUrl2,
                        pointimageUrl3: obj.pointimageUrl3,
                        buttonUrl: obj.buttonUrl,
                    }
                    : obj;
            });
        });
    }
    return (<>
      {isStart ? (<>
          {isEnd ? (<>
              <div className="p-likesystem__header p-likesystem__header--sub">
                <h1>デザイン診断結果</h1>
              </div>
              <div className="p-likesystem__body">
                <div className="p-likesystem__body__row">
                  <div className="p-likesystem__body__col">
                    <img src={imageUrl} alt={title}/>
                  </div>
                  <div className="p-likesystem__body__col">
                    <p className="p-likesystem__body__score-title">
                      あなたの選んだデザイン家具
                    </p>
                    <div className="p-likesystem__body__score">
                      {patterns.map(function (elem, index) {
                    return (<dl className="p-likesystem__body__score__child">
                            <dt>
                              <span>{elem.title}</span>
                            </dt>
                            <dd>
                              <span>{elem.score}点</span>
                            </dd>
                          </dl>);
                })}
                    </div>
                    <h2 className="p-likesystem__body__title">{title}</h2>
                    <p className="p-likesystem__body__description">
                      {description}
                    </p>
                  </div>
                </div>
            </div>
			<Swiper className="p-design__body__header__slider" modules={[Pagination]} loop={true} slidesPerView={1.5} spaceBetween={16} centeredSlides={true} pagination={{
                    el: ".swiper-pagination",
                    clickable: true,
                }} breakpoints={{
                    768: {
                        slidesPerView: 1.75,
                    }
                }}>
			  <SwiperSlide><img src={slideimageUrl1} alt=""/></SwiperSlide>
			  <SwiperSlide><img src={slideimageUrl2} alt=""/></SwiperSlide>
			  <SwiperSlide><img src={slideimageUrl3} alt=""/></SwiperSlide>
			  <div slot="container-end" className="swiper-pagination"></div>
			</Swiper>
            <div className="p-likesystem__body">
            	<div className="p-design__body__header__row">
                  <div className="p-design__body__header__col">
                      <p>KEY POINT</p>
                      <img src={pointimageUrl1} alt=""/>
                  </div>
                  <div className="p-design__body__header__col">
                      <p>MATERIAL</p>
                      <img src={pointimageUrl2} alt=""/>
                  </div>
                  <div className="p-design__body__header__col">
                      <p>ACCESSORY</p>
                      <img src={pointimageUrl3} alt=""/>
                  </div>
                </div>
            </div>
            <div className="p-likesystem__body">
	            <p className="p-reason__first__body">ぴったリビングでは、<br />お客様のデザイン診断結果に合った<br />デザイン提案をいたします。</p>
	        </div>
            <div className="p-reason__first">
	            <div className="p-reason__first__inner">
		            <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/design/suggestion_pc.png")} alt="デザイン×リフォーム専門店 ぴったリビング" className="pc-only"/>
	                <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/design/suggestion_sp.png")} alt="デザイン×リフォーム専門店 ぴったリビング" className="sp-only"/>
			    </div>
			</div>
			<aside className="l-cv--page">
          <div className="l-cv--page__col l-cv--page__col--estimate">
            <div className="l-cv--page__col__inner">
                <p className="l-cv--page__col__text">まずは、価格が知りたいという方<br />
                    現地調査・お見積スピード対応！</p>
                <h2 className="l-cv--page__col__title--medium">無料見積依頼</h2>
                <ul className="l-cv--page__col__button--estimate">
                    <li>
                      <a href="/estimate">
                        <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/cv_mail.svg")}/>お見積り依頼
                      </a>
                    </li>
                </ul>
            </div>
        </div>
			    <div className="l-cv--page__col l-cv--page__col--reserve">
			        <div className="l-cv--page__col__inner">
			            <p className="l-cv--page__col__text">土日・平日もお気軽にご来場ください！<br />体験型モデルハウス</p>
			            <h2 className="l-cv--page__col__title--large">来場見学</h2>
			            <ul className="l-cv--page__col__button--reserve">
						    <li><a href="/showroom-reserve">
						        <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/cv_reserve.svg")} alt=""/>
						        ご来店予約
						    	</a>
						    </li>
						</ul>
			        </div>
			    </div>
			</aside>
            </>) : (<div className="p-likesystem__question">
              <div className="p-likesystem__header p-likesystem__header--sub">
                <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/logo.png")} alt="デザイン×リフォーム専門店 リビングLABO"/>
                <h1>デザイン診断</h1>
              </div>
              <div className="p-likesystem__body">
                <p className="p-likesystem__body__center">{question}</p>
                <div className="p-likesystem__body__row">
                  {patterns.map(function (e, i) {
                    return (<Thumbnail key={i} stepIndex={stepIndex} id={i} category={e.category} patterns={patterns} plusStep={plusStep} updateScore={updateScore}/>);
                })}
                </div>
              </div>
            </div>)}
        </>) : (<>
          <div className="p-likesystem__header">
            <a href={"".concat(BASEURL)}>
              <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/logo.png")} alt="デザイン×リフォーム専門店 ぴったリビング"/>
            </a>
          </div>
          <div className="p-likesystem__hero">
            <h1>デザイン診断</h1>
          </div>
          <div className="p-likesystem__body">
            <div className="p-likesystem__body__center">
              <p>
                あなたのコノミのデザインを
                <br className="sp-only"/>
                見つけることができます！
              </p>
              <div className="p-likesystem__body__button" onClick={function () {
                setStepIndex(1);
                setIsStart(true);
            }}>
                <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/cv_design.svg")} alt="*"/>
                デザイン診断をはじめる
              </div>
            </div>
          </div>
        </>)}
    </>);
};
